<!-- 预览审核页面 -->
<template>
    <div class="PreviewAudit">
      <div class="Preview"  @click="auditOpenOrEnd" @keyup.space="auditOpenOrEnd">
        <div class="censorshipActive" @click.stop="" v-if="auditSwitch.replace">
          <div class="text">
            <i class="iconfont icon-warning2"></i> <span>{{$t('lang.CensorshipActive')}}</span>
          </div>
        </div>
        <div class="replaceVideo" @click.stop="" v-if="auditSwitch.replace">
            <video autoplay preload="auto" muted :src="replaceFileDialog.url" v-show="!thumbnailSwitch"></video>
            <i :class="['iconfont', thumbnailSwitch?'icon-zoomin':'icon-zoomout']" @click.stop="thumbnailSwitch=!thumbnailSwitch"></i>
        </div>
        <video-module
          v-if="inProgress"
          :height="StyleMessage.height"
          :width="StyleMessage.width"
          :source="socketData"
          deviceType="T"
          :rid="socketData.livePeerId"
          :oldReceiverInfoObj="socketData"
          :oldGetKernelStateObj="socketData"
          :useOldR="false"
          :sid="socketData.peerId"
          :status="socketData.status"
        />
        <div class="instructions">{{!auditSwitch.replace? $t('lang.censorshipCut'):$t('lang.censorshipEnd') }}</div>
      </div>
     <replacement-file-tips v-if="replaceFileDialog.show" :replaceFileDialog="replaceFileDialog"></replacement-file-tips>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import Outil from '@/assets/js/utils.js'
import toTips from '@/assets/js/toTipsObj'
import videoModule from '@/components/common/VideoC'
import replacementFileTips from './replacementFileTips.vue'
export default {
  data () {
    return {
      inProgress: false,
      // 正在live的信息
      socketData: {},
      // 预览视频样式问题
      StyleMessage: {
        width: '400px',
        height: '228px'
      },
      RMessage: {
        rid: 'fffffff110009c00'
      },
      auditSwitch: {
        replace: 1,
        show: false
      },
      // 替换video信息
      replaceVideoData: {},
      replaceSuccess: false,
      // 替换源样式
      replaceStyle: {
        width: '240px',
        height: '135px'
      },
      // thumbnail
      thumbnailSwitch: false,
      // 替换文件弹框
      replaceFileDialog: {
        show: false,
        url: ''
      }
    }
  },
  components: {
    videoModule,
    replacementFileTips
  },
  computed: {
    ...mapState({
      pageRWebsocket: (state) => state.websocket.pageRWebsocket
    })
  },
  created () {
    this.getRid()
    window.addEventListener('keydown', this.handkeyCode, true)
    this.getSwitchCommand()
    this.getOutputBuffer()
  },
  mounted () {
    this.StyleMessage = {
      width: document.body.scrollWidth + 'px',
      height: document.body.scrollHeight + 'px'
    }
  },
  methods: {
    handkeyCode (e) {
      if (e.keyCode === 32) {
        this.auditOpenOrEnd()
      }
    },
    getOutputBuffer () {
      this.axios.post(Outil.getUrl('/outputBuffer/getOutputBufferByProgramId'),
        { programId: this.$route.query.ProgramId }
      ).then((res) => {
        if (res.data.errorCode == '0x0') {
          const result = res.data.result
          this.replaceFileDialog.show = !(result && result.sourceId)
          this.replaceFileDialog.url = result && result.sourceUrl
        } else {
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.info(errorInfo)
        }
      }).catch(() => {
      })
    },
    getRid () {
      const param = {
        programId: this.$route.query.ProgramId
      }
      this.axios
        .post(Outil.getUrl('/program/getProgram'), param)
        .then(res => {
          if (res.data.errorCode == '0x0') {
            console.log()
            const result = res.data.result
            this.SchedulerPreview(result.rid, 1)
          } else {
            const errorInfo =
              this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.info(errorInfo)
          }
        })
        .catch(() => {

        })
    },
    // 查看切换状态
    getSwitchCommand () {
      this.axios.post(Outil.getUrl('/outputBuffer/getSwitchCommandByProgramId'),
        { programId: this.$route.query.ProgramId }
      ).then((res) => {
        if (res.data.errorCode == '0x0') {
          const result = res.data.result
          this.auditSwitch.replace = result
        } else {
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.info(errorInfo)
        }
      }).catch(() => {})
    },
    // 切换PGM流
    auditOpenOrEnd () {
      // switchCommand 0代表回到主源
      this.auditSwitch.show = true
      this.axios.post(Outil.getUrl('/outputBuffer/sendSwitchCommand'),
        { programId: this.$route.query.ProgramId, switchCommand: this.auditSwitch.replace ? 0 : 1 }
      ).then((res) => {
        if (res.data.errorCode == '0x0') {
          this.$message.success('Success')
          const result = res.data.result
          this.auditSwitch.replace = result.switchCommand
          // this.getSwitchCommand()
        } else {
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.info(errorInfo)
        }
      }).catch(() => {})
    },
    // scheduler页面预览的websocket
    SchedulerPreview (rid, type) {
      this.pageRWebsocket.send({
        message: { rid, categoryId: '2152857600', operationType: '102' },
        time: 1000,
        isOnce: false,
        key: 'getQueryKennel',
        success: (res) => {
          const data = res.data ? JSON.parse(res.data) : {}
          if (res.rid == rid) {
            data.SDI = true
            data.WebRSDIFeedUrl = data.WebRM3U8PlaybackUrl
            if (type == 1) {
              this.socketData = data
              this.inProgress = true
            } else {
              this.replaceSuccess = true
              this.replaceVideoData = data
            }
          }
        }
      })
    },
    // 结束scheduler页面的websocket
    EndSchedulerWebsocket () {
      if (this.pageRWebsocket) {
        this.$createWebsocket.pageRWebsocket('stop', 'getQueryKennel')
      }
    }
  }
}
</script>

<style scoped lang="less">
.PreviewAudit{
  position: fixed;
  // position: relative;
  // width: 100%;
  // height: 100%;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: #252525;
  .Preview{
    cursor: pointer;
    position: relative;
    // width: 100%;
    // height: 100%;
    .censorshipActive{
      position: absolute;
      top: 0;
      height: 135px;
      background: #F6445A;
      opacity: 0.25;
      width: 100%;
      z-index: 9999;
      text-align: center;
      .text{
        line-height: 135px;
        i{
          font-size: 48px;
        }
        span{
          color: red;
          font-size: 36px;
        }
      }
    }
    .replaceVideo{
      position: absolute;
      top: 0;
      left: 0;
      width: 240px;
      height: 135px;
      z-index: 99999;
      video{
        width: 240px;
        height: 135px;
      }
      .icon-zoomout{
        font-size: 37px;
        // background: black;
        position: absolute;
        left: 200px;
        bottom: 0;
      }
      .icon-zoomin{
        font-size: 37px;
        // background: red;
        position: absolute;
        left: 28px;
        bottom: 49px;
      }

    }
    .instructions{
      width: 100%;
      text-align: center;
      position: absolute;
      bottom: 0;
      z-index: 9999;
    }
  }

}
</style>
